module.exports = __webpack_public_path__ + "static/img/M-715-MUSA.d4a4a9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-715-MUSA.png
// module id = BwRl
// module chunks = 0